export default __webpack_public_path__ + "static/5-220d3794d15d25bf5b06d5371e21da47.jpeg";